<template>
	<div v-parallax-fit="parallax" class="hand" id="hand-1">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/14_Purchase_01_1@2x.png" alt="">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/holly/2.srt',
				'es': '/themes/rise-theme/resources/assets/audio/holly/2_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 7500,
					end: 9000,
					fromStyle: { transform: 'translateX(0%) translateY(-100%)', marginTop: '0px' },
					toStyle: { transform: 'translateX(-50%) translateY(-100%)', marginTop: '10px' },
					easing: 'linear'
				},
				{
					start: 9050,
					end: 11500,
					fromStyle: { transform: 'translateX(-50%) translateY(-100%)', marginTop: '0px' },
					toStyle: { transform: 'translateX(-50%) translateY(550%)', marginTop: '0px' },
					easing: 'linear'
				}
			]
		}
	},
	created() {
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const self = this;
		const audio = '/themes/rise-theme/resources/assets/audio/holly/2.mp3';
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/holly/evidence/7.png',
					url: 'https://www.multihousingnews.com/havenpark-capital-partners-pays-71m-for-minnesota-manufactured-homes/',
					link_title: {
						'en': "Havenpark Capital Partners Pays $71M for Minnesota Manufactured Homes",
						'es': 'Havenpark Capital Partners paga $71 millones por casas prefabricadas de Minnesota'
					},
				}
			],
			text: {
				'en': 'Although Havenpark is not a “Wall Street landlord,” meaning one that has publicly traded shares on the stock exchange, it manages its properties quite similarly. In the last 10 years, large-scale landlords have entered new markets that they had not previously invested in, such as single-family homes and manufactured communities.',
				'es': 'Aunque Havenpark no es un "propietario de Wall Street", es decir, uno que ha negociado públicamente acciones en la bolsa de valores, administra sus propiedades de manera bastante similar. En los últimos 10 años, los propietarios a gran escala han ingresado a nuevos mercados en los que no habían invertido anteriormente, como viviendas unifamiliares y comunidades prefabricadas.'
			}
		};
		const text = {
			'en': "Havenpark Communities, formerly known as Havenpark Capital Partners, is a private investment firm based in Utah. In the past seven years, Havenpark has expanded its property holdings aggressively, focusing on manufactured home communities.",
			'es': 'Havenpark Communities, anteriormente conocida como Havenpark Capital Partners, es una firma de inversión privada con sede en Utah. En los últimos siete años, Havenpark ha ampliado agresivamente sus propiedades, centrándose en las comunidades de viviendas prefabricadas.'
		};

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.marginTop == '10px') {
					self.$audioUrl.value = audio;
					self.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					self.$evidence.value = JSON.stringify(evidence);
					self.$readMore.value = text;
				}
			});
		});

		this.mutationObserver.observe(document.querySelector('#hand-1'), {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	}
}
</script>

<style lang="scss" scoped>
.hand {
	position: fixed;
	top: 50%;
	left: 100%;
	z-index: 2;
	max-width: 2000px;
	width: 100%;
	transition: all 0.1s linear;
}
</style>
